module.exports = __webpack_public_path__ + "img/avatar.42a5c269.webp";